import type { MatchDetailDto } from '@/api/backoffice-schemas';
import { getGameFromBackofficeVideoGame } from '@/utils/gameMappers';
import { MatchBanner } from './MatchBanner';
import { Score } from './Score';
import { Teams } from './Teams';

export type MatchCardProps = {
  data: MatchDetailDto;
};

export const MatchCard = (props: MatchCardProps) => {
  if (!props.data) {
    return null;
  }

  const {
    teamMatches,
    numberOfGames,
    matchType,
    league,
    videoGame,
    beginAt,
    status,
    draw,
  } = props.data;

  const team1 = teamMatches?.[0];
  const team2 = teamMatches?.[1];

  enum MatchType {
    best_of = 'Best of',
    first_to = 'First to',
    red_bull_home_ground = 'Redbull best of',
  }

  const matchTypeLabel = `${
    MatchType[matchType as keyof typeof MatchType]
  } ${numberOfGames}`;

  const leagueLabel = league?.name;

  const game = getGameFromBackofficeVideoGame(videoGame?.slug);

  return (
    <div className="flex flex-row items-center justify-between gap-2 rounded-lg bg-light-gray p-3 md:gap-3">
      <MatchBanner beginAt={beginAt} game={game} status={status || ''} />
      <Teams
        draw={draw}
        status={status || ''}
        team1={team1}
        team2={team2}
        winner={props.data.winner}
      />
      <div className="flex h-full w-[82px] flex-col items-start justify-around">
        <p className="font-semibold text-[11px] leading-3">{matchTypeLabel}</p>
        <p className="font-normal text-[10px] leading-3">{leagueLabel}</p>
      </div>
      <div className="grid grid-cols-1 grid-rows-2 gap-2">
        {team1 && (
          <Score
            draw={draw}
            isWinner={
              status === 'finished' &&
              !draw &&
              props.data.winner?.externalId === team1?.team?.externalId
            }
            status={status || ''}
            teamMatch={team1}
          />
        )}
        {team2 && (
          <Score
            draw={draw}
            isWinner={
              status === 'finished' &&
              !draw &&
              props.data.winner?.externalId === team2?.team?.externalId
            }
            status={status || ''}
            teamMatch={team2}
          />
        )}
      </div>
    </div>
  );
};
